import { Component, OnInit } from '@angular/core';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, AuthenticationService, RAFUnitOfWork, UtilityService } from 'src/app/core/core.module';
import { TimeEntry } from 'src/app/core/data/entities';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
    selector: 'app-time-add-dialog',
    templateUrl: './time-add-dialog.component.html',
    styleUrls: ['./time-add-dialog.component.scss'],
    standalone: false
})
export class TimeAddDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    filter: any;
    readOnly = false;
    entity: any;
    employeeInfos: any;
    timeCategories: any;
    employees: any;
    employee: any;
    employeeId: number;
    mode: any;
    allowEployeeSelection = false;
    allowAnyDaySelection = true;
    allowJobSelection = false;
    jobs: any;

    minDate: Date;
    maxDate: Date;
    validationMinDate: any;
    validationMaxDate: any;
    errorAction = 'saving';
    validationGroup = 'mainValidationGroup';
    isToastVisible = false;
    processing = false;

    onToolbarPreparing = SharedModule.onToolbarPreparing;

    constructor(
        public modalRef: BsModalRef,
        private uow: RAFUnitOfWork,
        private auth: AuthenticationService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        this.processing = true;
        this.timeCategories = await this.uow.getActiveTimeCategories();
        this.employees = this.uow.lookups.employees;
        const statuses = await this.uow.lookups.statuses;
        if (this.allowJobSelection)
            this.jobs = await this.uow.getJobs();

        if (!this.auth.userHasRole(this.auth.userValue, 'Admin'))
            this.timeCategories = this.timeCategories.filter((x) => {
                if (x.isVisibleToEmployee) return x;
            });

        if (this.mode === 'add') {
            this.entity = this.uow.timeEntries.createEntity() as TimeEntry;
            this.entity.created = moment(!!this.filter ? this.filter.date : new Date())
                .startOf('day')
                .toDate();
        }

        if (!!this.employee || !!this.employeeId) {
            this.entity.employeeId = this.employeeId ? this.employeeId : this.employee.id;
            this.allowEployeeSelection = false;
        } else {

        }

        if (!this.filter) {
            this.minDate = moment(new Date()).add(-10, 'days').toDate();
            this.maxDate = moment(new Date()).endOf('day').toDate();
        } else {
            this.minDate = moment(this.filter.date).startOf('day').toDate();
            this.maxDate = moment(this.filter.date).endOf('day').toDate();
            this.validationMinDate = moment(this.minDate).format('MM/DD/YYYY');
            this.validationMaxDate = moment(this.maxDate).format('MM/DD/YYYY');
        }

        this.processing = false;
    }

    save() {
        if (!this.validate()) return;
        this.appInfo.pleaseWaitShow();
        if (this.uow.hasChanges) {
            this.entity.edited = new Date();
        }
        this.appInfo.pleaseWaitHide();
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
